import React from 'react';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { Heading } from '../../components';

import css from './ListingPage.module.css';

const SectionDescription = props => {
  const { text } = props;

  if (!text) {
    return null;
  }

  return (
    <div className={classNames([css.customFields, css.description])} id="listing-description">
      <Heading as="h2" rootClassName={classNames(css.sectionHeading, css.sectionHeadingColored)}>
        <FormattedMessage id="SectionDescription.title" />
      </Heading>
      <div className={css.sectionDescription}>{text}</div>
    </div>
  );
};

export default SectionDescription;
